var _title, _desc, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCatalog = function SvgCatalog(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Catalog")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Catalog",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Catalog-Icon",
    transform: "translate(6.000000, 8.000000)",
    fill: "#165E96"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.8261842,17.5102912 L21.7393538,17.5102912 C17.3003743,17.5102912 14.9907767,18.2371932 13.0438248,19.698799 L13.0438248,2.18895358 C14.9903339,0.726679092 17.3003743,0 21.7393538,0 L22.8261842,0 L22.8261842,17.5102912 Z M1.08683042,18.6045897 L2.17388224,18.6050355 C5.4345949,18.6050355 9.94198553,18.8765371 11.956463,20.7935433 L10.4031523,20.7935433 C8.72386758,19.9719055 6.59182909,19.562647 3.26071266,19.562647 L0,19.562647 L0,3.28325205 L1.08683042,2.18877526 L1.08683042,18.6045897 Z M2.17381582,6.68723091e-05 L3.26086764,6.68723091e-05 C7.69984706,6.68723091e-05 10.0096661,0.72719178 11.956618,2.18879755 L11.956618,19.6988659 C10.0096661,18.2370372 7.69984706,17.5103581 3.26086764,17.5103581 L2.17381582,17.5103581 L2.17381582,6.68723091e-05 Z M23.9131696,2.18886442 L25,3.28267249 L25,19.5620674 L21.7388445,19.5620674 C18.4081709,19.5620674 16.2761324,19.9713259 14.5968477,20.7931866 L13.043537,20.7931866 C15.0584573,18.8759575 19.5649623,18.6046789 22.8261178,18.6046789 L23.9131696,18.6046789 L23.9131696,2.18886442 Z",
    id: "Combined-Shape"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCatalog, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/catalog.c9fd58d6.svg";
export { ForwardRef as ReactComponent };